<template>
  <div>
    <v-overlay :value="loading" :z-index="999999">
      <v-col class="align-center justify-center text-center">
        <v-progress-circular
          :size="120"
          :width="8"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <h3 class="my-3">Agregando usuario...</h3>
      </v-col>
    </v-overlay>
    <v-dialog
      v-model="confirmB2CDialog"
      min-width="600"
      max-width="900"
      min-height="600"
      max-height="900"
      @keydown.esc="closeConfirmB2CDialog"
    >
      <v-card class="pa-6">
        <v-card-title class="text-uppercase">
          <div>Agregar usuario y membresia</div>
        </v-card-title>
        <hr class="my-3" />
        <v-card-text class="my-0 py-0">
          <p>Esta acción creará un usuario y membresia con estado <b>pagado.</b></p>
          <p>Recuerde verificar que el usuario ya realizó el pago.</p>
        </v-card-text>
        <hr class="my-3" />
        <v-card-actions class="justify-end">
          <v-btn color="primary" rounded @click="createB2CUser">
            Aceptar
          </v-btn>
          <v-btn text color="primary" rounded @click="closeConfirmB2CDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmB2BDialog"
      min-width="600"
      max-width="900"
      min-height="600"
      max-height="900"
      @keydown.esc="closeConfirmB2BDialog"
    >
      <v-card class="pa-6">
        <v-card-title class="text-uppercase">
          <div>Agregar usuario</div>
        </v-card-title>
        <hr class="my-3" />
        <v-card-text class="my-0 py-0">
          <p>Esta acción creará un usuario B2B</p>
          <p>Recuerde verificar la existencia de este usuario en la empresa asociada</p>
        </v-card-text>
        <hr class="my-3" />
        <v-card-actions class="justify-end">
          <v-btn color="primary" rounded @click="createB2BUser">
            Aceptar
          </v-btn>
          <v-btn text color="primary" rounded @click="closeConfirmB2BDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbarOk" color="green" :timeout="timeout">
      Usuario creado exitosamente

      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="snackbarOk = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarFailed" color="red" :timeout="timeout">
      {{ snackbarFailedMessage || 'Error al crear usuario' }}

      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="snackbarFailed = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-row class="ma-0 my-4 align-center justify-space-between">
      <h1 class="text-h5 font-weight-bold">Crear Usuario</h1>
    </v-row>

    <v-form ref="newUserForm" v-model="formValid">
      <v-col>
        <!-- País -->
        <h3>País</h3>
        <v-row class="my-1">
          <v-col cols="4">
            <v-select
              label="País"
              v-model="selectedCountry"
              :items="countries"
              :loading="loadingCountries"
              @change="changeCountry"
              item-value="id"
              item-text="text"
              :rules="requiredRules"
              outlined
              dense
              hide-details="auto"
            >
              <template v-slot:selection="{ item }">
                <img v-if="item.flag" :src="item.flag" height="16" class="mr-2" style="vertical-align:middle" />
                <span>{{ item.text }}</span>
              </template>
              <template v-slot:item="{ item }">
                <img v-if="item.flag" :src="item.flag" height="16" class="mr-2" style="vertical-align:middle" />
                <span>{{ item.text }}</span>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <template v-if="selectedCountry.id">
          <h3>Tipo de usuario</h3>
          <!-- Tipo de usuario -->
          <v-row class="my-1">
            <v-col cols="4">
              <v-select
                label="Tipo de usuario"
                v-model="newUser.type"
                :rules="requiredRules"
                :items="userTypes"
                required
                outlined
                dense
                hide-details="auto"
                @change="getData"
              ></v-select>
            </v-col>
            <v-col cols="4" class="d-flex align-center">
              <div class="d-flex align-center" style="gap: 8px;">
                <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">¿Es usuario VIP?</span>
                <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">No</span>
                <v-switch
                  v-model="newUser.isVip"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                  color="primary"
                  inset
                ></v-switch>
                <span style="font-size: 0.85rem; color: rgba(0,0,0,0.6);">Sí</span>
              </div>
            </v-col>
          </v-row>
        </template>

        <template v-if="newUser.type">
          <h3>Datos de usuario</h3>
          <!-- Nombre, apellido y RUT -->
          <v-row class="my-1">
            <v-col cols="4">
              <v-text-field
                label="Nombres"
                v-model="newUser.name"
                :rules="nameRules"
                required
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Apellidos"
                v-model="newUser.surname"
                :rules="nameRules"
                required
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="countryIdentifierPlaceholder"
                v-model.lazy="newRut"
                required
                outlined
                dense
                @input="changeRut"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-1">
            <v-col cols="4">
              <v-text-field
                label="Correo electrónico"
                v-model="newUser.email"
                :rules="emailRules"
                required
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </template>

        <!-- Dirección (solo B2C de México o Argentina: el backend exige la dirección completa) -->
        <template v-if="newUser.type === 'B2C' && isMexicoCountry">
          <h3>Dirección</h3>
          <mexico-address-fields v-model="formAddress" :required="addressRequired"></mexico-address-fields>
        </template>
        <template v-else-if="newUser.type === 'B2C' && isArgentinaCountry">
          <h3>Dirección</h3>
          <argentina-address-fields v-model="formAddress" :required="addressRequired"></argentina-address-fields>
        </template>

        <!-- Beneficio (solo para B2B) -->
        <h3 v-if="newUser.type === 'B2B'">Beneficio</h3>
        <v-row class="my-1" v-if="newUser.type === 'B2B'">
          <v-col cols="4">
            <v-select
              label="Empresa"
              v-model="companySelected"
              :items="companies"
              item-text="name"
              item-value="id"
              :rules="requiredRules"
              :loading="!companies.length"
              @change="getCompanyContracts"
              return-object
              outlined
              dense
              required
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              label="Contrato"
              v-model="contractSelected"
              :items="contracts"
              item-text="displayName"
              item-value="id"
              :rules="requiredRules"
              :loading="loadingContracts"
              return-object
              outlined
              dense
              :disabled="!companySelected"
              :required="!!companySelected"
              hide-details="auto"
              @change="onContractChange"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="Créditos"
              v-model.number="credits"
              type="number"
              min="0"
              step="1"
              :rules="creditsRules"
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="Información extra"
              v-model="extraInfo"
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Planes del contrato -->
        <v-row class="my-1" v-if="contractSelected">
          <v-col cols="4">
            <v-select
              label="Plan contratado"
              v-model="contractPlanSelected"
              :items="contractPlanOptions"
              :loading="loadingContractPlanes"
              hint="Con un plan, el usuario solo podrá activar ese plan del contrato"
              persistent-hint
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <div class="caption grey--text text--darken-1 mb-2">Planes del contrato</div>
            <v-progress-linear
              v-if="loadingContractPlanes"
              indeterminate
              color="primary"
              class="mb-2"
            ></v-progress-linear>
            <v-simple-table v-else-if="contractPlanes.length" dense class="pa-2">
              <thead>
                <tr>
                  <th class="text-left">Plan</th>
                  <th class="text-left">Descripción</th>
                  <th class="text-left">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in contractPlanes" :key="p.id">
                  <td>{{ p.plan.name }}</td>
                  <td>{{ p.plan.internalDescription }}</td>
                  <td>
                    <v-chip x-small :color="p.visible ? 'green darken-1' : 'grey darken-1'" dark>
                      {{ p.visible ? 'Activo' : 'Inactivo' }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <span v-else class="caption grey--text">Sin planes asociados</span>
          </v-col>
        </v-row>

        <!-- Membresía (solo para B2C) -->
        <h3 v-if="newUser.type === 'B2C'">Membresía</h3>
        <v-row class="my-1" v-if="newUser.type === 'B2C'">
          <v-col cols="5">
            <v-text-field
              label="Nombre peludo"
              v-model="pet.name"
              :rules="nameRules"
              required
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              label="Sexo"
              v-model="pet.sex"
              :items="[
                { text: 'Macho', value: 'male' },
                { text: 'Hembra', value: 'female' }
              ]"
              :rules="requiredRules"
              required
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-menu
              ref="menu"
              v-model="showPetBirthdateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pet.birthdate"
                  label="Fecha de nacimiento"
                  prepend-icon="mdi-calendar"
                  required
                  :rules="requiredRules"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details="auto"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="pet.birthdate"
                :active-picker.sync="activePicker"
                :max="new Date().toISOString().substr(0, 10)"
                min="2005-01-01"
                @change="saveDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="my-1" v-if="newUser.type === 'B2C'">
          <v-col cols="2">
            <v-select
              label="Especie"
              v-model="pet.species"
              :items="[
                { text: 'Gato', value: 'cat' },
                { text: 'Perro', value: 'dog' }
              ]"
              :rules="requiredRules"
              required
              outlined
              dense
              hide-details="auto"
              @change="getBreeds(pet.species)"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              label="Raza"
              v-model="pet.breed"
              :items="breeds"
              :loading="!breeds.length && pet.species != ''"
              value="id"
              item-text="name"
              :rules="requiredRules"
              required
              outlined
              dense
              return-object
              hide-details="auto"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="my-1" v-if="newUser.type === 'B2C'">
          <v-col cols="5">
            <v-select
              label="Plan"
              v-model="planSelected"
              :items="plans"
              item-text="name"
              item-value="id"
              return-object
              :rules="requiredRules"
              :loading="loadingPlans"
              @change="getPlans"
              required
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              label="Modalidad de pago"
              v-model="paymentInterval"
              :items="[
                { text: 'Anual', value: 1 },
                { text: 'Mensual', value: 2 }
              ]"
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>
          <!--<v-col cols="4">
            <v-select
              label="Cupón"
              v-model="couponSelected"
              :items="coupons"
              :loading="!coupons.length"
              item-text="name"
              item-value="id"
              return-object
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>-->
        </v-row>
        <v-row class="my-1" v-if="newUser.type === 'B2C'">
          <v-col cols="5">
            <v-menu
              ref="menu"
              v-model="showStartDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  label="Fecha inicio membresía"
                  prepend-icon="mdi-calendar"
                  required
                  :rules="requiredRules"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details="auto"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                :active-picker.sync="activePicker"
                :max="new Date().toISOString().substr(0, 10)"
                min="2023-01-01"
                @change="saveDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-btn :disabled="!formValid" color="primary" rounded @click="validate">
            Crear
          </v-btn>
        </v-row>
      </v-col>
    </v-form>
  </div>
</template>

<script>
import UsersService from '../services/users.service';
import AddressService from '../services/address.service';
import RutUtils from '../utils/rut.utils';
import { phoneCountryCodeFromPrefix } from '../utils/phone-prefix.utils';
import CompaniesService from '../services/companie.service';
import ContratoService from '../services/contrato.service';
import PlansService from '../services/plans.service';
import PetsService from '../services/pets.service';
import CouponsService from '../services/coupons.service';
import CreateUserMembreshipModal from '../components/CreateUserMembershipModal';
import Overlay from '../components/Overlay.vue';
import CountryService from '../services/countries.service';
import MexicoAddressFields from '../components/MexicoAddressFields.vue';
import ArgentinaAddressFields from '../components/ArgentinaAddressFields.vue';
import {
  isMexico,
  isArgentina,
  emptyAddress,
  isAddressEmpty,
  missingMexicanAddressFields,
  missingArgentineAddressFields,
  toAddressPayload
} from '../utils/address.utils';

export default {
  components: {
    MexicoAddressFields,
    ArgentinaAddressFields
  },
  comments: {
    CreateUserMembreshipModal,
    Overlay
  },
  data() {
    return {
      showModal: false,
      showBirthdayMenu: false,
      showPetBirthdateMenu: false,
      showStartDateMenu: false,
      activePicker: null,
      formValid: false,
      selectedCountry: { id: '', iso: '', text: '' },
      newRut: '',
      newUser: {
        type: '',
        country: { text: '', value: '' },
        name: '',
        rut: '',
        surname: '',
        email: '',
        phoneCountryCode: '56',
        phone: '',
        birthday: '',
        isVip: false,
        address: {
          region: '',
          commune: '',
          address: '',
          number: '',
          extra: ''
        }
      },
      pet: {
        name: '',
        species: '',
        birthdate: '',
        sex: '',
        breedId: '',
        age: { quantity: 0, unit: '' }
      },
      // Dirección de México o de Argentina (MexicoAddressFields, ArgentinaAddressFields);
      // vacía = no se manda.
      formAddress: emptyAddress(),
      countries: [],
      regions: [],
      communes: [],
      userTypes: ['B2B', 'B2C'],
      breeds: [],
      plans: [],
      coupons: [],
      companies: [],
      contracts: [],
      paymentInterval: null,
      speciesSelected: null,
      companySelected: null,
      contractSelected: null,
      originSelected: null,
      couponSelected: null,
      planSelected: null,
      startDate: null,
      credits: null,
      extraInfo: '',
      requiredRules: [v => !!v || 'Este campo es requerido'],
      nameRules: [v => !!v || 'El nombre es requerido'],
      emailRules: [
        v => !!v || 'Un correo electrónico es requerido',
        v => /.+@.+/.test(v) || 'Debe ser un correo electrónico válido'
      ],
      /*rutRules: [
        v => !!v || 'El nombre es requerido',
        v => RutUtils.validateRut(v) || 'RUT no válido'
      ],*/
      loadingCountries: false,
      loadingContracts: false,
      loadingContractPlanes: false,
      contractPlanes: [],
      contractPlanSelected: null,
      confirmB2CDialog: false,
      confirmB2BDialog: false,
      timeout: 2000,
      snackbarOk: false,
      snackbarFailed: false,
      snackbarFailedMessage: '',
      loading: false,
      loadingPlans: false,
      loadingCoupons: false,
      loadingCommunes: false,
      countryIdentifierPlaceholder: 'RUT',
      origin: '',
      creditsRules: [
        v =>
          v === null ||
          v === '' ||
          v === undefined ||
          (Number.isInteger(Number(v)) && Number(v) >= 0) ||
          'Solo se aceptan números enteros positivos'
      ]
    };
  },
  computed: {
    // "Todos los planes" (null) deja el acceso sin restricción; un plan lo restringe a ese plan.
    contractPlanOptions() {
      return [
        { text: 'Todos los planes', value: null },
        ...this.contractPlanes.filter(p => p.visible).map(p => ({ text: p.plan.name, value: p.planId }))
      ];
    },
    isMexicoCountry() {
      return isMexico(this.selectedCountry.iso);
    },
    isArgentinaCountry() {
      return isArgentina(this.selectedCountry.iso);
    },
    // La dirección es opcional en el alta, pero si se empieza a cargar debe quedar completa.
    addressRequired() {
      return !isAddressEmpty(this.formAddress);
    }
  },
  mounted() {
    this.getCountries();
    this.getRegions();
  },
  methods: {
    cleanData() {
      this.formAddress = emptyAddress();
      this.plans = [];
      this.coupons = [];
      this.contracts = [];
      this.contractPlanes = [];
      this.paymentInterval = null;
      this.speciesSelected = null;
      this.companySelected = null;
      this.contractSelected = null;
      this.originSelected = null;
      this.couponSelected = null;
      this.planSelected = null;
      this.credits = null;
      this.extraInfo = '';
      this.newUser = {
        type: '',
        country: { text: '', value: '' },
        name: '',
        rut: '',
        surname: '',
        email: '',
        phoneCountryCode: '56',
        phone: '',
        birthday: '',
        address: {
          region: '',
          commune: '',
          address: '',
          number: '',
          extra: ''
        }
      };
      this.pet = {
        name: '',
        species: '',
        birthdate: '',
        sex: '',
        breedId: null,
        age: { quantity: 0, unit: '' }
      };
    },
    changeCountry(value) {
      const country = this.countries.find(c => c.id === value);
      this.plans = [];
      this.coupons = [];
      this.contracts = [];
      this.companies = [];
      this.paymentInterval = null;
      this.speciesSelected = null;
      this.companySelected = null;
      this.contractSelected = null;
      this.originSelected = null;
      this.couponSelected = null;
      this.planSelected = null;
      this.formAddress = emptyAddress();
      this.selectedCountry = country;
      if (country.iso == 'CL') {
        this.countryIdentifierPlaceholder = 'RUT';
        this.getRegions();
      } else {
        this.countryIdentifierPlaceholder = 'DNI';
      }
      if (this.newUser.type === 'B2B') {
        this.getCompanies();
      }
    },
    async getData() {
      if (this.newUser.type === 'B2B') {
        await this.getCompanies();
        this.contracts = [];
        this.contractSelected = null;
        this.contractPlanes = [];
        this.plans = [];
      } else {
        await this.getPlans();
        await this.getCoupons();
      }
    },
    handleCreate() {
      if (this.newUser.type == 'B2C') {
        this.confirmB2CDialog = true;
      } else {
        this.createB2BUser();
      }
    },
    async getCountries() {
      try {
        this.loadingCountries = true;
        const response = await CountryService.getAllCountries(true);
        if (response.status === 'ok') {
          this.countries = response.data.map(c => {
            return {
              text: c.name ?? '',
              flag: c.flagUrlImage ?? '',
              iso: c.iso,
              id: c.id,
              phonePrefix: c.phonePrefix
            };
          });
        }
        this.loadingCountries = false;
      } catch (err) {
        this.loadingCountries = false;
      }
    },
    async getRegions() {
      AddressService.getAllRegions().then(res => {
        if (res.status === 'ok') {
          this.regions = res.data.map(r => ({
            code: r.codigo,
            name: r.nombre
          }));
        }
      });
    },
    async getCommunesByRegion(region) {
      this.loadingCommunes = true;
      await AddressService.getCommunesByRegion(region).then(res => {
        if (res.status === 'ok') {
          this.communes = res.data.map(d => ({
            name: d.nombre,
            code: d.codigo
          }));
        }
      });
      this.loadingCommunes = false;
    },
    saveDate(date) {
      this.$refs.menu.save(date);
      this.showBirthdayMenu = false;
      this.showPetBirthdateMenu = false;
      this.showStartDateMenu = false;
    },
    // Los faltantes de la dirección según el formulario del país elegido.
    missingAddressFields() {
      if (this.isMexicoCountry) return missingMexicanAddressFields(this.formAddress);
      if (this.isArgentinaCountry) return missingArgentineAddressFields(this.formAddress);
      return [];
    },
    async validate() {
      if (this.$refs.newUserForm.validate()) {
        if (this.newUser.type === 'B2C' && this.addressRequired) {
          const missing = this.missingAddressFields();
          if (missing.length) {
            this.snackbarFailedMessage = `Completa la dirección: ${missing.join(', ')}`;
            this.snackbarFailed = true;
            return;
          }
        }
        try {
          if (this.newUser.type == 'B2B') {
            this.triggerConfirmB2BDialog();
          } else {
            this.triggerConfirmB2CDialog();
          }
        } catch (err) {
          console.error('Error al crear el usuario:', err.message);
        }
      }
    },
    async createB2CUser() {
      this.closeConfirmB2CDialog();
      this.loading = true;
      this.pet.age = this.getAge(this.pet.birthdate);
      this.newUser.country = this.selectedCountry.iso;
      const data = this.generateNewUserMembershipObj();
      const response = await UsersService.createManualUser('b2c', data);
      if (response.status === 'ok') {
        this.snackbarOk = true;
        this.cleanData();
        this.$refs.newUserForm.resetValidation();
      } else {
        this.snackbarFailedMessage = response.message;
        this.snackbarFailed = true;
      }
      this.loading = false;
    },
    async createB2BUser() {
      this.closeConfirmB2BDialog();
      this.loading = true;
      this.newUser.country = this.selectedCountry.iso;
      const data = this.generateNewUserCompanyAccessObj();
      const response = await UsersService.createManualUser('b2b', data);
      if (response.status === 'ok') {
        this.snackbarOk = true;
        this.$refs.newUserForm.resetValidation();
      } else {
        this.snackbarFailedMessage = response.message;
        this.snackbarFailed = true;
      }
      this.loading = false;
    },
    async getCompanies() {
      this.loadingData = true;
      const res = await CompaniesService.getCompanies(1, 100, '', 'active', this.selectedCountry.id);
      if (res.status === 'ok') {
        this.companies = res.data.companies;
      }
      this.loadingData = false;
    },
    async getPlans() {
      this.loadingPlans = true;
      const res = await PlansService.getB2CPlanToAssociate(this.selectedCountry.id);
      if (res.status === 'ok') {
        this.plans = res.data;
      }
      this.loadingPlans = false;
    },
    async getCompanyPlan() {
      this.loadingPlans = true;
      const res = await PlansService.getPlanByCompanyId(this.companySelected.id);
      if (res.status === 'ok') {
        this.plans = res.data.plans;
      }
      this.loadingPlans = false;
    },
    async getCompanyContracts() {
      this.contracts = [];
      this.contractSelected = null;
      this.contractPlanes = [];
      this.loadingContracts = true;
      const res = await ContratoService.getByCompanyId(this.companySelected.id);
      if (res.status === 'ok') {
        this.contracts = res.data.map(c => ({
          ...c,
          displayName: `${c.codigo.replace(/-/g, '')}${c.producto ? ` - ${c.producto.nombre}` : ''}`
        }));
      }
      this.loadingContracts = false;
    },
    async onContractChange() {
      this.contractPlanes = [];
      this.contractPlanSelected = null;
      if (!this.contractSelected) return;
      this.loadingContractPlanes = true;
      const res = await ContratoService.getById(this.contractSelected.id);
      if (res.status === 'ok') {
        this.contractPlanes = res.data.planes ?? [];
      }
      this.loadingContractPlanes = false;
    },
    async getBreeds(species) {
      this.loadingBreeds = true;
      try {
        const breeds = await PetsService.getBreeds(species);
        this.breeds = breeds.data;
        this.breeds.splice(0, 0, { name: 'Mestizo', id: null });
      } catch (err) {
        console.error('Error al obtener las razas:', err.message);
      } finally {
        this.loadingBreeds = false;
      }
    },
    async getCoupons() {
      this.loadingData = true;
      const res = await CouponsService.getActiveCoupons(this.selectedCountry.iso); // Iso
      if (res.status === 'ok') {
        this.coupons = res.data;
      }
      this.loadingData = false;
    },
    changeRut(rut) {
      if (this.selectedCountry.iso === 'CL') {
        this.newUser.rut = RutUtils.clean(rut);
        this.newRut = RutUtils.formatRut(rut);
      } else {
        this.newUser.rut = rut;
      }
    },
    changePhone(phone) {
      this.newUser.phone = phone;
    },
    getAge(birthdate) {
      const now = new Date();
      const birth = new Date(birthdate);

      let years = now.getFullYear() - birth.getFullYear();
      let months = now.getMonth() - birth.getMonth();

      if (months < 0) {
        years--;
        months += 12;
      }

      if (years > 0) {
        return { quantity: years, unit: 'Y' };
      } else {
        return { quantity: months, unit: 'M' };
      }
    },
    triggerConfirmB2CDialog() {
      this.confirmB2CDialog = true;
    },
    closeConfirmB2CDialog() {
      this.confirmB2CDialog = false;
    },
    triggerConfirmB2BDialog() {
      this.confirmB2BDialog = true;
    },
    closeConfirmB2BDialog() {
      this.confirmB2BDialog = false;
    },
    getCountryCodePhone() {
      return phoneCountryCodeFromPrefix(this.selectedCountry.phonePrefix, this.selectedCountry.iso);
    },
    generateNewUserMembershipObj() {
      this.newUser.phoneCountryCode = this.getCountryCodePhone();
      const address = {
        street: this.newUser.address.street,
        number: this.newUser.address.number,
        extra: this.newUser.address.extra,
        commune: {
          code: '',
          name: this.newUser.address.commune
        },
        placeId: '',
        region: {
          code: '',
          name: this.newUser.address.region
        }
      };
      this.newUser.type = this.newUser.type.toLowerCase();
      this.pet.breedId = this.pet.breed?.id ?? null;
      delete this.pet.breed;
      const user = {
        ...this.newUser,
        address,
        isVip: this.newUser.isVip
      };
      // México y Argentina: la dirección del formulario, o ninguna si no se cargó.
      if (this.isMexicoCountry || this.isArgentinaCountry) {
        if (isAddressEmpty(this.formAddress)) delete user.address;
        else user.address = toAddressPayload(this.formAddress, this.selectedCountry.iso);
      }
      return {
        user,
        pet: this.pet,
        planId: this.planSelected.id,
        startDate: this.startDate,
        paymentInterval: this.paymentInterval
      };
    },
    generateNewUserCompanyAccessObj() {
      const totalAccounts = this.credits;
      return {
        name: this.newUser.name,
        surname: this.newUser.surname,
        email: this.newUser.email,
        rut: this.newUser.rut,
        country: this.newUser.country,
        countryIso: this.newUser.country,
        planId: this.contractPlanSelected,
        companyId: this.companySelected.id,
        ...(this.contractSelected?.id && { contratoId: this.contractSelected.id }),
        ...(totalAccounts !== null && totalAccounts !== undefined && { totalAccounts }),
        ...(this.extraInfo && { extraInfo: this.extraInfo })
      };
    }
  }
};
</script>
